import { render, staticRenderFns } from "./PrivateReport.vue?vue&type=template&id=2c3f6aad&"
import script from "./PrivateReport.vue?vue&type=script&lang=js&"
export * from "./PrivateReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports